import React from "react";
import "../styles/categoryGrid.css";

const CategoryGrid = ({ categories, onCategoryClick }) => {
  return (
    <div className="category-grid-wrapper-card">
      <h2 className="category-grid-title">Shop By Collections</h2>

      <div className="category-grid">
        {categories.map((cat) => (
          <div
            key={cat.id}
            className="category-card"
            onClick={() => onCategoryClick(cat.id)}
          >
            <img
              src={cat.category_image}
              alt={cat.category_name}
              className="category-img"
            />

            <div className="category-overlay">
              <h4>{cat.category_name}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default CategoryGrid;
